<template>
  <footer class="relative z-10 w-full py-3 mt-48 border-t border-zinc-200">
    <div
      class="flex flex-col items-center justify-between w-full px-5 mx-auto md:flex-row max-w-7xl"
    >
      <ol class="flex items-center justify-start mb-2">
        <li class="px-2">
          <router-link
            to="/terms/terms_of_customer"
            class="text-xs transition-all duration-300 text-zinc-600 hover:text-primary"
          >
            服務條款
          </router-link>
        </li>
        <li class="px-2">
          <router-link
            to="/terms/site_privacy"
            class="text-xs transition-all duration-300 text-zinc-600 hover:text-primary"
          >
            隱私權政策
          </router-link>
        </li>
        <li class="px-2">
          <router-link
            to="/terms/return_policy"
            class="text-xs transition-all duration-300 text-zinc-600 hover:text-primary"
          >
            退換貨政策
          </router-link>
        </li>
      </ol>
      <p class="text-xs text-center text-zinc-600">
        本系統由 <router-link to="/">快樂買購物系統</router-link> 維護
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "MainFooter",
};
</script>
